<template>
    <entity-editor
        entity="research"
        :id="id"
        api-name="researchRequests"
        :new-entity="newResearchRequest"
        @isDirtyChange="handleIsDirtyChange"
    >
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.reference" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Reference" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-select
                        v-model="doc.researchPeriodId"
                        :rules="[requiredRule]"
                        :items="researchPeriods"
                        item-text="name"
                        item-value="id"
                        :disabled="isLoading"
                        label="Research Period"
                        outlined
                        dense
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Research Period" />
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.realName" label="Player Name" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.characterName" label="Character Name" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.topic" label="Topic" outlined auto-grow></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.notes" label="Notes" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.url" label="Url" outlined></v-text-field>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import api from '@/api'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import RequiresLabel from '../../components/RequiredLabel'
export default {
    name: 'ResearchRequestEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    components: {
        'label-required': RequiresLabel,
    },
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            researchPeriods: [],
        }
    },
    mounted() {
        this.getResearchPeriods()
    },
    methods: {
        newResearchRequest() {
            return {
                characterName: '',
                realName: '',
                notes: '',
                reference: '',
                researchPeriodId: 0,
                teamId: null,
                topic: '',
                url: '',
            }
        },
        getResearchPeriods() {
            this.isLoading = true
            api.get('researchPeriod/getAll')
                .then(res => {
                    this.researchPeriods = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
